<template>
    <div class="map-container-height">
        <!--Will Not Toggle Properly if put into a class...Leave inline-->
        <div @dblclick="zoomIn" @contextmenu="zoomOut" style="width:100%; height: 100%;" id='route'></div>
    </div>
</template>

<script>
    import mapboxgl from 'mapbox-gl';
    import {mapActions, mapGetters} from 'vuex'
    import mapHelpers from "../../utils/helpers/mapHelpers";
    export default {
        name: 'route-map-view',
        props: {
            tab: {
                type: String,
                required: true
            }
        },
        data: () => ({
            map: null,
            accessToken: 'pk.eyJ1IjoiaG9za2luc3QiLCJhIjoiY2s5M2N6NHprMDEwNDNkbWJieThzbm1hNiJ9.0F7I8B6DKLxTzAXg1oN9Hw',
            mapStyle: 'mapbox://styles/mapbox/outdoors-v12',
            coordinates: [-122.9110, 49.2057],
            routeId: 0,
            color: '',
            currentMarkers: [],
            clickCounter: 0
        }),
        mounted() {
            this.createMap();
        },
        methods: {
            ...mapActions({
                getRouteLocations: 'routes/getRouteAndLocations',
                getIsolateRouteLocations: 'routes/getIsolatedRoute'
            }),
            createMap() {
                mapboxgl.accessToken = this.accessToken
                // init the map
                this.map = new mapboxgl.Map({
                    container: 'route',
                    style: this.mapStyle,
                    minzoom: 1.3,
                    center: this.coordinates,
                    zoom: 10,
                })
                this.map.on('load', () => {
                    this.map.resize();
                });
                this.map['doubleClickZoom'].disable()
                this.map.addControl(new mapboxgl.NavigationControl())
                this.map.addControl(
                    new mapboxgl.GeolocateControl({
                        positionOptions: {
                            enableHighAccuracy: true
                        },
                        showAccuracyCircle: false,
                        trackUserLocation: true
                    })
                );
                this.addMarkers()
            },
            async setRoutePins(route) {
                await this.getIsolateRouteLocations(route.id)
            },
            addMarkers() {
                this.clearMarkers()
                this.routeCoordinates.forEach(route => {
                    let marker = new mapboxgl.Marker({ color: route.color })
                        .setLngLat([route.longitude, route.latitude])
                        .addTo(this.map)
                    marker.getElement().addEventListener('click', () => {
                        this.setRoutePins(route);
                    });
                    this.currentMarkers.push(marker);
                })
            },
            clearMarkers() {
                this.currentMarkers.forEach(marker => {
                    marker.remove()
                    marker = []
                })
            },
            zoomIn() {
                let z = this.map.getZoom()
                this.map.flyTo({ zoom: z + 2, speed: 0.2, curve: 1, essential: true })
            },
            zoomOut (e) {
                e.preventDefault()
                this.clickCounter++
                if (this.clickCounter === 2) {
                    let z = this.map.getZoom()
                    this.map.flyTo({ zoom: z - 2, speed: 0.2, curve: 1, essential: true })
                    this.clickCounter = 0
                }
            },
        },
        watch: {
            tab() {
               this.map.resize()
            },
            async routeCoordinates() {
                await this.addMarkers()
            },
            async clickCounter () {
                await mapHelpers.sleep(500).then(() => this.clickCounter = 0)
            }
        },
        computed: {
            ...mapGetters({
                routeLocations: 'routes/routeLocations'
            }),
            routeCoordinates () {
                if(!this.routeLocations){ //avoid console errors when there are no routes
                    return [];
                }
                return this.routeLocations.map(route => {
                    route.coordinates = [route.longitude, route.latitude]
                    if (this.routeId !== route.id) {
                        this.color = route.color
                        this.routeId = route.id
                    }
                    return route
                })
            },
        }
    }
</script>
<style>
    .map-container-height{
        height: 100%;
    }
    .mapboxgl-ctrl-top-right .mapboxgl-ctrl {
        margin: 14px 12px 0 0 !important;
    }
    .mapboxgl-canvas {
        height: 100% !important;
    }
    .mapboxgl-marker:hover {
        cursor: pointer;
    }
</style>
